import script from "./AttributeFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeFilter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__